;
define("global_views_message.tpl", function(){});

